module.exports = __webpack_public_path__ + "img/Still-Thinking-3-mobile.4ef654c2.png";